import CompactErrorView from "./CompactErrorView";

function CompactError({ error }) {
  return error && <CompactErrorView error={error} />;
}

export default CompactError;
